// extracted by mini-css-extract-plugin
export default {"root":"form_root__Hlozj","form":"form_form__mtz0F","stepperForm__collapsible":"form_stepperForm__collapsible__y2apo"};